import { Button } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';
import Container from 'src/components/shared/Container';

const JapSuccessPage = () => {
	const navigate = useNavigate();
	return (
		<div
			style={{
				border: '1px solid transparent',
			}}
			className={`levelup-bg-secondary parent_dark_theme_bg_color}`}
		>
			<div className="sm:pb-5">
				<Container className="w-[92%] max-w-[1366px] sm:w-[96%]">
					<div className="mb-[372px] mt-[220px] sm:mb-[100px] sm:mt-[100px]">
						<div className="flex justify-center">
							{/* <Lottie loop animationData={congratulationsCheckAnimation} play={true} style={{ width: '84px' }} /> */}
						</div>

						<div className="flex justify-center text-[24px] font-[500] text-[#FAFAFC]">
							<div className="max-w-[487px] text-center sm:max-w-[100%]">Congratulations!</div>
						</div>

						<div className="mt-2 flex justify-center text-[16px] font-[400] text-[#C7C9D9]">
							<div className="max-w-[487px] text-center sm:max-w-[100%]">
								Your payment was successful! Our team will reach out to you on the next steps. Stay tuned for
								personalised job opportunities.
							</div>
						</div>

						<div className="mt-8 flex justify-center gap-4 sm:flex-col-reverse">
							<Button
								style={{
									border: '1px solid #7777E7',
								}}
								color={'dark'}
								onClick={() => {
									// navigate('/dashboard');
									navigate('/my-applications');
								}}
							>
								Okay, Got it!
							</Button>
							<Button
								color="purplePlaced"
								onClick={() => window.open('https://calendly.com/levelup-support/levelup-support')}
							>
								Book Support
							</Button>
						</div>
						<div className="mt-[72px] text-center text-[12px] font-[400] text-[#C7C9D9] sm:max-w-[100%]">
							Reach out to support@leveup.inc for any issues or queries.
						</div>
					</div>
				</Container>
			</div>
		</div>
	);
};

export default JapSuccessPage;
